import { render, staticRenderFns } from "./MarcacaoOnLine.vue?vue&type=template&id=2d08742a&scoped=true&"
import script from "./MarcacaoOnLine.vue?vue&type=script&lang=js&"
export * from "./MarcacaoOnLine.vue?vue&type=script&lang=js&"
import style0 from "./MarcacaoOnLine.vue?vue&type=style&index=0&id=2d08742a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d08742a",
  null
  
)

export default component.exports